<div class="container-fluid">
    <div class="p-4 mb-3 fondo rounded">
        <h4 class="text-center text-secondary text-uppercase font-weight-bold">
            <i class="fa fa-list-alt"></i> Listado de documento(s) rechazados:&nbsp;&nbsp;
        </h4><br><br><br>
        <div class="container-fluid table-responsive">
            <form [formGroup]="forma">
                <table datatable [dtTrigger]="dtTrigger" [dtOptions]="dtOptions" class="display table text-center hover"
                    style="width: 100% !important;">
                    <thead class="table-header">
                        <tr class="text-uppercase">
                            <th>Contrato</th>
                            <th>Cupo</th>
                            <th>Nombre del documento</th>
                            <th>Observación</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody *ngIf='documentFilter'>
                        <tr *ngFor="let field of documentFilter; let i=index">
                            <td data-name="ContractNumber">{{ field.contractNumber}}</td>
                            <td data-name="QuotaNumber">{{ field.quotaNumber}}</td>
                            <td data-name="documentName">{{ field.baseDocument.docName }}</td>
                            <td data-name="observation">{{ field.observation || 'Sin Observación'}}</td>
                            <td data-name="actions">
                                <input [formControlName]="createTabName(field.baseDocument.docName)" type="file" id="file{{i}}"
                                    style="display:none;" type="file" size="2048"
                                    [accept]="['.pdf']" name="files{{i}}" #upFiles [required]
                                    (change)="assignAttachment($event.target.files, i, field.baseDocument.docName, field.id)"
                                    [multiple]="false">
                                <div *ngIf='!field.baseDocument.generated'>
                                    <label *ngIf='!upFiles?.value' for="file{{i}}" class="btn btn-primary mx-3">
                                        <i class="fas fa-upload"></i><br>
                                    </label>
                                    <label *ngIf='upFiles?.value' for="file{{i}}" class="btn btn-primary mx-3">
                                        {{ (upFiles?.value) ? getFileName(upFiles.value) : 'Anexar documento' }}
                                    </label>
                                </div>
                                <div *ngIf='field.baseDocument.generated'>
                                    <button (click)='goToFormUrl(field.baseDocument.docName)' class="btn btn-primary mx-3">
                                        <i class="fas fa-arrow-right"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngIf='!documentFilter'>
                        <tr>
                            <td colspan="7" class="no-data-available">No se encontraron resultados</td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="forma.errors && forma.touched">
                        <div class="px-4 mx-5 mb-0" style="display: flex;justify-content: center;">
                            <label class="d-flex align-items-center" style="display: flex; justify-content: center;">
                                <span class="alert alert-danger font-weight-bold text-uppercase">
                                    Faltan documentos requeridos, verifique
                                </span>
                            </label>
                        </div>
                    </tbody>
                </table>
            </form>
            <div class="guardar_container w-100 d-flex align-items-center justify-content-center mt-2">
                <button class="btn btn-sm btn-secondary text-uppercase font-weight-bold"
                    (click)="activateModal.close()">
                    <i class="fa fa-times-circle-o" aria-hidden="true"></i> Cerrar
                </button>&nbsp;&nbsp;
                <button (click)="saveDocuments()" type="submit" class="btn btn-primary font-weight-bold m-2"
                    >
                    <i class="fa fa-save"></i>
                    Guardar
                </button>
            </div>
        </div>
        <ngx-spinner color="#c2af85" size="medium" type="ball-fussion">
            <p class='color-spinner-text'>Cargando... </p>
        </ngx-spinner>
    </div>
</div>
